const createPt110InitState = () => ({
  productList: [],
  colorTitle: '',
  sizeTitle: '',
  categoryNmOptionFlg: 0,
  productSortKbnList: [],
  isDisplaySortFlg: false,
});

const createPt110ReqModelState = () => ({
  totalRecord: null,
  fromRecord: null,
  toRecord: null,
  pageSize: 16,
  pageNo: 1,
  pointFlg: 0,
});

const state = () => ({
  pt110Init: createPt110InitState(),
  pt110ReqModel: createPt110ReqModelState(),
});

const mutations = {
  RESET_PT110_STATE(currentState) {
    currentState.pt110Init = createPt110InitState();
    currentState.pt110ReqModel = createPt110ReqModelState();
  },
  SET_PT110_INIT(currentState, payload = {}) {
    currentState.pt110Init = payload || {};
  },
  MERGE_PT110_INIT(currentState, payload = {}) {
    currentState.pt110Init = Object.assign({}, currentState.pt110Init, payload);
  },
  SET_PT110_REQ_MODEL(currentState, payload = {}) {
    currentState.pt110ReqModel = payload || {};
  },
  MERGE_PT110_REQ_MODEL(currentState, payload = {}) {
    currentState.pt110ReqModel = Object.assign({}, currentState.pt110ReqModel, payload);
  },
};

const getters = {
  pt110Init: currentState => currentState.pt110Init,
  pt110ReqModel: currentState => currentState.pt110ReqModel,
};

export {
  createPt110InitState,
  createPt110ReqModelState,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
